export const SEARCH_TYPES = {
  ENTIRE: 'entire',
  ROOM: 'room',
};
